module.exports = __webpack_public_path__ + "img/eye_icon.a2501334.svg";